import { SELECTED_ALL_DISPUTES } from '../../components/Customer/Disputes/utils';

export const FETCH_DISPUTES = 'DISPUTES/FETCH_DISPUTES_DATA';
export const FETCH_DISPUTE_MESSAGES = 'DISPUTES/FETCH_DISPUTES_MESSAGES';
export const START_FETCH_DISPUTES_LOADER = 'DISPUTES/START_FETCH_DISPUTES_LOADER';
export const START_FETCH_MESSAGES_LOADER = 'DISPUTES/START_FETCH_MESSAGES_LOADER';
export const SEND_DISPUTE_MESSAGE = 'DISPUTES/SEND_DISPUTE_MESSAGE';
export const CONFIRM_DISPUTE_MESSAGE = 'DISPUTES/CONFIRM_DISPUTE_MESSAGE';
export const CLEAR_DISPUTE_MESSAGE_DATA = 'DISPUTES/CLEAR_DISPUTE_MESSAGE_DATA';
export const SELECTED_DISPUTES = 'DISPUTES/SELECTED_DISPUTES';
export const FETCH_SINGLE_DISPUTE = 'DISPUTES/FETCH_SINGLE_DISPUTE';
export const SUBMIT_DISPUTE_SUCCESS_MESSAGE = 'DISPUTES/SUBMIT_DISPUTE_SUCCESS_MESSAGE';
export const FETCH_SINGLE_DISPUTE_LOADING = 'DISPUTES/FETCH_SINGLE_DISPUTE_LOADING';
export const CLOSE_SINGLE_DISPUTE = 'DISPUTES/CLOSE_SINGLE_DISPUTE';
export const ACCEPT_TERMS_AND_CONDITIONS = 'DISPUTES/ACCEPT_TERMS_AND_CONDITIONS';
export const CLEAR_DISPUTES_DATA = 'DISPUTES/CLEAR_DISPUTES_DATA';

const initialState = {
  disputes: [],
  fetchDisputesLoading: false,
  messages: undefined,
  fetchMessagesLoader: false,
  sendDisputeMessageData: {},
  confirmDisputeMessageData: {},
  selectedDisputes: [],
  singleDisputeData: {},
  fetchSingleDisputeLoading: false,
  submitSuccessMessage: '',
  acceptedTermsAndConditions: {}
};

const selectDisputeHandler = (
  { selectedDisputes, disputes },
  { disputeID, isSelected, isSuperUser }
) => {
  let disputeIDs = [...selectedDisputes];
  if (disputeID === SELECTED_ALL_DISPUTES) {
    disputeIDs = isSelected
      ? disputes.flatMap(({ disputeInfo }) => {
          if (!isSuperUser && !disputeInfo.openDispute) return [];
          return disputeInfo.disputeID;
        })
      : [];
  } else if (isSelected) disputeIDs.push(disputeID);
  else disputeIDs = disputeIDs.filter(id => id !== disputeID);
  return [...disputeIDs];
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DISPUTES:
      return {
        ...state,
        disputes: action.payload,
        fetchDisputesLoading: initialState.loading,
        selectedDisputes: [...initialState.selectedDisputes],
        sendDisputeMessageData: { ...initialState.sendDisputeMessageData },
        confirmDisputeMessageData: { ...initialState.confirmDisputeMessageData }
      };
    case FETCH_DISPUTE_MESSAGES:
      return {
        ...state,
        messages: action.payload,
        fetchMessagesLoader: false
      };
    case START_FETCH_DISPUTES_LOADER:
      return {
        ...state,
        fetchDisputesLoading: action.payload || true
      };
    case START_FETCH_MESSAGES_LOADER:
      return {
        ...state,
        fetchMessagesLoader: action.payload || true
      };
    case SEND_DISPUTE_MESSAGE:
      return {
        ...state,
        sendDisputeMessageData: action.payload
      };
    case CONFIRM_DISPUTE_MESSAGE:
      return {
        ...state,
        confirmDisputeMessageData: action.payload
      };
    case CLEAR_DISPUTE_MESSAGE_DATA:
      return {
        ...state,
        sendDisputeMessageData: { ...initialState.sendDisputeMessageData },
        confirmDisputeMessageData: { ...initialState.confirmDisputeMessageData }
      };
    case SELECTED_DISPUTES:
      return {
        ...state,
        selectedDisputes: selectDisputeHandler(state, action.payload)
      };
    case FETCH_SINGLE_DISPUTE:
      return {
        ...state,
        singleDisputeData: action.payload,
        fetchSingleDisputeLoading: false
      };
    case CLOSE_SINGLE_DISPUTE:
      const dispute = { ...state.singleDisputeData };
      dispute.disputeInfo.openDispute = false;
      return {
        ...state,
        singleDisputeData: dispute,
        fetchSingleDisputeLoading: false
      };
    case FETCH_SINGLE_DISPUTE_LOADING:
      return {
        ...state,
        singleDisputeData: { ...initialState.singleDisputeData },
        fetchSingleDisputeLoading: action.payload || true,
        submitSuccessMessage: initialState.submitSuccessMessage
      };
    case SUBMIT_DISPUTE_SUCCESS_MESSAGE:
      return {
        ...state,
        submitSuccessMessage: action.payload
      };
    case ACCEPT_TERMS_AND_CONDITIONS:
      return {
        ...state,
        acceptedTermsAndConditions: action.payload
      };
    case CLEAR_DISPUTES_DATA:
      return {
        ...state,
        disputes: initialState.disputes
      };
    default:
      return state;
  }
};
